import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LiveAssetStatus } from '@app/shared/models/live-status.model';
import { Observable } from 'rxjs';
import { ENDPOINTS } from '@core/constants/endpoints';
import { map } from 'rxjs/operators';
import { AssetStatusAdapter } from '@core/services/adapters/asset-status.adapter';
import { HttpClientSkippingInterceptorsService } from '@core/services/http-client-skipping-interceptors.service';
import { Asset } from '@app/shared/models/asset.model';
import { AssetAdapter } from '@core/services/adapters/asset.adapter';

@Injectable()
export class AssetService {
    constructor(
        private http: HttpClient,
        private httpSkippingInterceptors: HttpClientSkippingInterceptorsService,
        private assetAdapter: AssetAdapter,
        private assetStatusAdapter: AssetStatusAdapter
    ) {}

    getLiveStatus(assetId: number): Observable<LiveAssetStatus> {
        return this.http.get(`${ENDPOINTS.apis.assets.base}/${assetId}/livestatus`).pipe(
            map((response: any) => {
                return this.assetStatusAdapter.adapt(response);
            })
        );
    }

    getImage(assetId: number): Observable<Blob> {
        const headers = this.httpSkippingInterceptors.getAuthHeaders();

        return this.httpSkippingInterceptors
            .get(`${ENDPOINTS.apis.assets.base}/${assetId}/image`, {
                headers,
                observe: 'response',
                responseType: 'blob',
            })
            .pipe(map((response) => response.body));
    }

    getAsset(assetId: number, verbose = false): Observable<Asset> {
        const params = new HttpParams().set('verbose', String(verbose));

        return this.http
            .get(`${ENDPOINTS.apis.assets.base}/${assetId}`, { params })
            .pipe(map((response) => this.assetAdapter.adapt(response)));
    }
}
